import React, { useContext } from 'react';
import { ToolsContext } from '../../ToolsContext.js';
import { StopPropertyEditor } from './StopsPropertyEditor.js';
import { StopPicker } from './StopPicker.js';

export function Stops() {
    const tool = useContext(ToolsContext);
    let panelHeight = '82vh';

    return (
        <>
            <div style={{ height: panelHeight }}>
                {
                    (tool.propertyEditor == null) ? 
                        <StopPicker className="flex align-content-center" />
                    :
                        <StopPropertyEditor key={tool.propertyEditor.edit.stop_id} selectedItem={tool.propertyEditor.edit}></StopPropertyEditor>
                }
            </div>
        </>
    );
}
